"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _RadioGroup = _interopRequireDefault(require("../hocs/RadioGroup"));
var _RadioController = _interopRequireDefault(require("../hocs/RadioController"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const propTypes = {
  size: _propTypes.default.number,
  checked: _propTypes.default.bool
};
const defaultProps = {
  type: 'primary',
  size: 22
};
function Radio(props) {
  return /*#__PURE__*/_react.default.createElement(RadioContainer, props);
}
const RadioContainer = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n  overflow: hidden;\n  border-width: 1.5px;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  height: ", "px;\n  width: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n"])), _ref => {
  let {
    size
  } = _ref;
  return size;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size;
}, _ref3 => {
  let {
    size
  } = _ref3;
  return size;
}, _ref4 => {
  let {
    theme,
    checked
  } = _ref4;
  return checked ? theme.colors.MAIN.PRIMARY : theme.colors.FONT.CONTRAST;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.MAIN.PRIMARY;
});
Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
Radio.Group = _RadioGroup.default;
Radio.Controller = _RadioController.default;
var _default = exports.default = Radio;